module.exports = __webpack_public_path__ + "img/api-server.5b632b45.svg";